/**
 * EnergyConnect.WebApi | v1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const NetSettlementGroup = {
    NotSpecified: 'NotSpecified',
    NetSettlementGroup0: 'NetSettlementGroup0',
    NetSettlementGroup1: 'NetSettlementGroup1',
    NetSettlementGroup2: 'NetSettlementGroup2',
    NetSettlementGroup3: 'NetSettlementGroup3',
    NetSettlementGroup4: 'NetSettlementGroup4',
    NetSettlementGroup5: 'NetSettlementGroup5',
    NetSettlementGroup6: 'NetSettlementGroup6',
    NetSettlementGroup99: 'NetSettlementGroup99',
} as const;
export type NetSettlementGroup = typeof NetSettlementGroup[keyof typeof NetSettlementGroup];

